export default __webpack_public_path__ + "static/media/Calko384.325ee4e1.png";